import {OktaAuth, toRelativeUrl} from '@okta/okta-auth-js';
import {Security} from '@okta/okta-react';
import React, {useEffect, useState} from 'react';
import {Route, Routes} from 'react-router-dom';
import Footer from "./components/Footer";
import Header from "./components/Header";
import AgentSignInForm from './pages/AgentSignInForm';
import Home from './pages/Home';
import InsuredRegistration from "./pages/InsuredRegistration.jsx";
import InsuredSignInForm from './pages/InsuredSignInForm';
import CreatePasswordModal from "./pages/password/createNewPassword/CreatePasswordModal";
import {RequestPasswordReset} from "./pages/password/requestPasswordReset/RequestPasswordReset";
import ResetPassword from "./pages/password/resetPassword/ResetPassword";
import SMSVerification from "./pages/smsverification/SMSVerification";
import WelcomePage from './pages/welcomepage/WelcomePage';

export default function AppWithRouterAccess() {

  const onAuthRequired = () => { window.location.pathname = ('/login'); };
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    window.location.pathname = (toRelativeUrl(originalUri, window.location.origin));
  };
  const [config, setConfig] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
      fetch("/api/v2/oktaConfig")
        .then(res => res.json())
          .then(res => {
              const generalConfig = {onAuthRequired, pkce: true, issuer: res.issuer, useInteractionCodeFlow: true,}
              setConfig({
                  agent: new OktaAuth({...res.agent, ...generalConfig}),
                  insured: new OktaAuth({...res.insured, ...generalConfig})
              });
              setLoading(false);
          });
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
      return null;
  } else {
    return (<div className="ga_login-app-container">
        <Header/>
        <Security oktaAuth={config.agent} restoreOriginalUri={restoreOriginalUri}>
          <Routes>
            <Route path="/" element={<Home insuredRedirectUri={config.insured.options.redirectUri}/>}/>
            <Route path="/agent" element={<AgentSignInForm/>}/>
            <Route path="/registration" element={<InsuredRegistration/>}/>
            <Route path={'/welcome'} element={() => <WelcomePage username="David"/>}/>
            <Route path={'/verify'} element={<SMSVerification/>}/>
            <Route path={'/password'} element={<CreatePasswordModal/>}/>
            <Route path="/password/reset/:token" element={<ResetPassword/>}/>
            <Route path={'/request-password-reset'} element={<RequestPasswordReset/>}/>
          </Routes>
        </Security>
        <Security oktaAuth={config.insured} restoreOriginalUri={restoreOriginalUri}>
          <Routes>
            <Route path="/insured" element={<InsuredSignInForm/>}/>
          </Routes>
        </Security>
        <Footer/>
      </div>
      );
  }
};
